export const MOBILE_MAX_WIDTH = '500px';
export const DESKTOP_MAX_WIDTH = '1040px';

export const BREAKPOINTS = {
  DESKTOP: 'screen and (min-width: 1200px)'
}

export const SUPPORTS_HOVER = 'screen and (hover: hover) and (pointer: fine)';